import { Component, NgZone } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AppDialogConfig, DialogService } from "./dialog.service";

@Component({
  selector: "app-global-dialog",
  templateUrl: "./global-dialog.component.html",
  standalone: false
})
export class GlobalDialogComponent {
  public visible = false;
  public dialog: AppDialogConfig = null;

  constructor(
    public dialogService: DialogService,
    private translate: TranslateService,
    private zone: NgZone
  ) {}

  public close(): void {
    this.visible = false;
    this.dialogService.close();
  }

  public closeLabel(dialog: AppDialogConfig): string {
    return dialog && dialog.closeLabel ? dialog.closeLabel : this.translate.instant("common.close");
  }

  public runAction(dialog: AppDialogConfig): void {
    const action = dialog && dialog.action ? dialog.action : null;
    this.close();
    if (action) {
      window.setTimeout(() => this.zone.run(action), 0);
    }
  }
}
